/**
 * Type-safe localStorage wrapper
 */

export const storage = {
  get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      if (!item) {
        return null;
      }
      return JSON.parse(item) as T;
    } catch {
      return null;
    }
  },

  getString(key: string): string | null {
    return localStorage.getItem(key);
  },

  set<T>(key: string, value: T): void {
    localStorage.setItem(key, JSON.stringify(value));
  },

  setString(key: string, value: string): void {
    localStorage.setItem(key, value);
  },

  remove(key: string): void {
    localStorage.removeItem(key);
  },

  clear(): void {
    localStorage.clear();
  },

  setWithExpiry(key: string, value: unknown, seconds: number): void {
    const now = new Date();
    const item = {
      value,
      expiry: now.getTime() + seconds * 1000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  },

  getWithExpiry<T>(key: string): T | null {
    try {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr) as { value: T; expiry: number };
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch {
      return null;
    }
  },
};
